
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 9.525 9.525","version":"1.1","id":"svg6813"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',{attrs:{"id":"defs6807"}}),_c('g',{attrs:{"id":"layer1","transform":"translate(0 -287.475)"}},[_c('g',{attrs:{"transform":"matrix(.26126 0 0 .26143 0 287.431)","id":"galka"}},[_c('ellipse',{attrs:{"transform":"translate(0 .168)","ry":"18.217","rx":"18.229","cy":"18.217","cx":"18.229","data-name":"Ellipse 1197","id":"Ellipse_1197","fill":"#64d282"}}),_c('g',{attrs:{"transform":"rotate(135 11.791 16.24)","data-name":"Group 8116","id":"Group_8116"}},[_c('path',{staticClass:"cls-2",attrs:{"transform":"translate(10.296 5.879)","d":"M0-.067l3.825-.477.162 11.305H0z","data-name":"Path 5206","id":"Path_5206","fill":"#fff"}}),_c('path',{staticClass:"cls-2",attrs:{"transform":"translate(-2.172 5.346)","data-name":"Rectangle 6151","id":"Rectangle_6151","fill":"#fff","d":"M0 0h16.342v3.987H0z"}})])])])])
          )
        }
      }
    